
import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function TopBar() {
  const [weather, setWeather] = useState(null);
  const [dateStr, setDateStr] = useState('');

  useEffect(() => {
    const now = new Date();
    const formatted = now.toLocaleDateString('ar-EG', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    setDateStr(formatted);
  }, []);

  useEffect(() => {
    axios
      .get(
        'https://api.open-meteo.com/v1/forecast?latitude=31.5&longitude=34.5&current_weather=true&timezone=auto'
      )
      .then((res) => setWeather(res.data.current_weather))
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="text-white py-2" style={{ background: '#00436d' }}>
      <div className="container">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
          <div className="mb-2 mb-md-0">
            <span className="me-3">{dateStr}</span>
            {weather && (
              <span className="me-3">
                🌤️ {Math.round(weather.temperature)}°C
              </span>
            )}
            <span className="me-3">غزة</span>
          </div>

          <div className='d-none d-md-block d-lg-block'> 
            <i className="bi bi-person-circle me-2 ms-2"></i>
            <a href="https://moatasem-karawan.xyz/login" target='blank' className="text-white text-decoration-none">
              تسجيل الدخول
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
